'use strict';

function ConfigurationMarketClassFareInfluencesController($scope, dataRetrieverService, dataService) {
  dataService.setRetriever(dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', 'configuration-market-class-fare-influences-mode')).setCustomSearchCriteriaRules([]);
  $scope.customRemove = function (rowsToBeRemovedFromServer) {
    return dataService.remove(rowsToBeRemovedFromServer);
  };
  $scope.customSave = function (rowsToSave, data) {
    return dataService.save(rowsToSave, data);
  };
  $scope.customSaveValidation = function (rowsToSave, data) {
    return dataService.validate(rowsToSave, data);
  };
  $scope.makeExportToCsv = function (data) {
    return dataService.exportToCsv(data);
  };
}
ConfigurationMarketClassFareInfluencesController.$inject = ['$scope', 'DataRetrieverService', 'ConfigurationMarketClassFareInfluencesDataService'];
module.exports = ConfigurationMarketClassFareInfluencesController;